export default "__VITE_ASSET__fV_Q1uTp__"